/* 收货客户配置 */
import request from '@/utils/http';
const OTP = '/api-tms';

// 分页查询
export const operateOrderConfigQueryByPage = (data) => {
    return request({
        url: `${OTP}/businessWarehouseAppointmentConfig/queryPage`,
        method: 'post',
        data
    });
};

// 修改
export const operateOrderConfigUpdate = (data) => {
    return request({
        url: `${OTP}/businessWarehouseAppointmentConfig/updateById`,
        method: 'post',
        data
    });
};

// 新增
export const operateOrderConfigAdd = (data) => {
    return request({
        url: `${OTP}/businessWarehouseAppointmentConfig/add`,
        method: 'post',
        data
    });
};

// 删除
export const operateOrderConfigDelete = (data) => {
    return request({
        url: `${OTP}/businessWarehouseAppointmentConfig/delete`,
        method: 'post',
        data
    });
};

// 启用
export const operateOrderConfigEnable = (data) => {
    return request({
        url: `${OTP}/businessWarehouseAppointmentConfig/enable`,
        method: 'post',
        data
    });
};

// 停用
export const operateOrderConfigDisable = (data) => {
    return request({
        url: `${OTP}/businessWarehouseAppointmentConfig/disable`,
        method: 'post',
        data
    });
};
